import React, { useCallback } from 'react';
import classNames from 'classnames';
import { DesktopStrongIcon, MobileStrongIcon } from 'src/monet/icons';
import { IconButton } from 'src/common/icon-button';

export const EditorContentFormDevicePreviewToggles = ({
  onToggleChange,
  isMobilePreview,
}: {
  onToggleChange: ({ isMobilePreview }: { isMobilePreview: boolean }) => void;
  isMobilePreview: any;
}) => {
  const getButtonClasses = useCallback((isActive: boolean) => {
    return classNames({
      'text-bedrock-black': isActive,
      'text-bedrock-dark-gray': !isActive,
    });
  }, []);

  return (
    <div className='flex space-x-2 items-center'>
      <IconButton
        onClick={() => {
          onToggleChange({ isMobilePreview: false });
        }}
      >
        <span className={getButtonClasses(!isMobilePreview)}>
          <DesktopStrongIcon />
        </span>
      </IconButton>
      <IconButton
        onClick={() => {
          onToggleChange({ isMobilePreview: true });
        }}
      >
        <span className={getButtonClasses(isMobilePreview)}>
          <MobileStrongIcon />
        </span>
      </IconButton>
    </div>
  );
};
